import { axios, handleError } from "../../lib";
import { message } from "antd";

export const getAllHmos = () => async () => {
  try {
    const response = await axios.get("/admin/hmo/all");
    return response.data || [];
  } catch ({ response }) {
    handleError(response);
    return [];
  }
};

export const createHmo = (data) => async () => {
  try {
    const response = await axios.post("/admin/hmo/create", data);
    if (response.status === "success") {
      message.success(response.message || "HMO created successfully", 5);
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch ({ response }) {
    handleError(response);
    return { success: false };
  }
};

export const updateHmo = (id, data) => async () => {
  try {
    const response = await axios.post(`/admin/hmo/update/${id}`, data);
    if (response.status === "success") {
      message.success(response.message || "HMO updated successfully", 5);
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch ({ response }) {
    handleError(response);
    return { success: false };
  }
};

export const toggleHmoStatus = (id) => async () => {
  try {
    const response = await axios.post(`/admin/hmo/toggle-status/${id}`);
    if (response.status === "success") {
      message.success(response.message || "HMO status updated", 5);
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch ({ response }) {
    handleError(response);
    return { success: false };
  }
};

export const getAllHmoCustomers = (query = "") => async () => {
  try {
    const url = `/admin/hmo/all-customers${query ? `?${query}` : ""}`;
    const response = await axios.get(url);
    return response;
  } catch ({ response }) {
    handleError(response);
    return null;
  }
};

export const getHmoCustomers = (hmoId, query = "") => async () => {
  try {
    const url = `/admin/hmo/customers/${hmoId}${query ? `?${query}` : ""}`;
    const response = await axios.get(url);
    return response;
  } catch ({ response }) {
    handleError(response);
    return null;
  }
};

export const getPendingHmoApprovals = (query = "") => async () => {
  try {
    const url = `/admin/hmo/pending-approvals${query ? `?${query}` : ""}`;
    const response = await axios.get(url);
    return response;
  } catch ({ response }) {
    handleError(response);
    return null;
  }
};

export const approveHmoUser = (userId, data) => async () => {
  try {
    const response = await axios.post(`/admin/hmo/approve/${userId}`, data);
    if (response.status === "success") {
      message.success(response.message || "HMO approved successfully", 5);
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch ({ response }) {
    handleError(response);
    return { success: false };
  }
};

export const rejectHmoUser = (userId, data) => async () => {
  try {
    const response = await axios.post(`/admin/hmo/reject/${userId}`, data);
    if (response.status === "success") {
      message.success(response.message || "HMO rejected successfully", 5);
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch ({ response }) {
    handleError(response);
    return { success: false };
  }
};

export const extendHmoExpiry = (userId, data) => async () => {
  try {
    const response = await axios.post(`/admin/hmo/extend-expiry/${userId}`, data);
    if (response.status === "success") {
      message.success(response.message || "HMO expiration extended successfully", 5);
      return { success: true, data: response.data };
    }
    return { success: false };
  } catch ({ response }) {
    handleError(response);
    return { success: false };
  }
};
